import { render } from "./jobs.vue?vue&type=template&id=4c832606&ts=true"
import script from "./jobs.vue?vue&type=script&lang=ts"
export * from "./jobs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__